import axios from 'axios';
import { ArgumentNullError, throwIfNull } from '../errors';

const endpoint = 'user';

export default {
    /**
     * @param {String} password
     * @param {String} passwordConfirm
     * @param {String} email
     */
    async changePasswordAsync(password, passwordConfirm) {
        ArgumentNullError.throw(password, 'password', this.changePasswordAsync.name)
        ArgumentNullError.throw(passwordConfirm, 'passwordConfirm', this.changePasswordAsync.name)

        await axios.put(`${endpoint}/change-password`, { password, passwordConfirm })
    },

    async resetPasswordAsync(password, passwordConfirm, email) {
        ArgumentNullError.throw(password, 'password', this.resetPasswordAsync.name)
        ArgumentNullError.throw(passwordConfirm, 'passwordConfirm', this.resetPasswordAsync.name)
        ArgumentNullError.throw(email, 'email', this.resetPasswordAsync.name)

        await axios.put(`${endpoint}/reset-password`, { password, passwordConfirm, email })
    },

    async signUpAsync(user) {
        ArgumentNullError.throw(user, 'user', this.signUpAsync.name)
        const response = await axios.post(`${endpoint}/signUp`, user);
        return response.data;
    },

    async signUpWithEmailAsync({ email, password, passwordConfirm, roleName, supplierInternalId, suppliers }) {
        ArgumentNullError.throw(email, 'email', this.signUpWithEmailAsync.name)
        ArgumentNullError.throw(password, 'password', this.signUpWithEmailAsync.name)
        ArgumentNullError.throw(passwordConfirm, 'passwordConfirm', this.signUpWithEmailAsync.name)
        ArgumentNullError.throw(roleName, 'roleName', this.signUpWithEmailAsync.name)
        const response = await axios.post(`${endpoint}/signUp/email`, { email, password, passwordConfirm, roleName, supplierInternalId, suppliers });
        return response.data;
    },

    async getAll() {
        const response = await axios.get(`${endpoint}/GetUsers`);
        return response.data;
    },

    async getPagedAsync({ pageIndex, pageSize }) {
        ArgumentNullError.throw(pageIndex, 'pageIndex', this.getPagedAsync.name)
        ArgumentNullError.throw(pageSize, 'pageSize', this.getPagedAsync.name)

        const response = await axios.get(`${endpoint}/paged`, {
            params: { pageIndex, pageSize },
        });

        return response.data;
    },

    async search(SupplierId) {
        throwIfNull(SupplierId, 'SupplierId')
        const response = await axios.get(`${endpoint}/search`, {
            params: {
                supplierId: SupplierId.supplierId
            }
        });
        return response.data;

    },
    async updateAsync(userId, user) {
        ArgumentNullError.throw(userId, 'userId', this.updateAsync.name)
        const response = await axios.put(`${endpoint}/${userId}`, user);
        return response.data;
    },
    async getById(id) {
        const response = await axios.get(`${endpoint}/GetUser/${id}`);
        return response.data;
    },
};
